import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";
import { db } from "../firebase";

export const SUPPORT_STATUSES = ["new", "open", "waiting_customer", "resolved", "closed"];
export const SUPPORT_PRIORITIES = ["low", "normal", "high", "urgent"];

export const subscribeSupportTickets = (onData, onError) => {
  const ticketsQuery = query(collection(db, "supportTickets"), orderBy("updatedAt", "desc"));
  return onSnapshot(
    ticketsQuery,
    (snapshot) => onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
    onError
  );
};

export const updateSupportTicket = (ticketId, changes) => updateDoc(
  doc(db, "supportTickets", ticketId),
  { ...changes, updatedAt: serverTimestamp() }
);

export const subscribeSupportMessages = (ticketId, onData, onError) => {
  const messagesQuery = query(
    collection(db, "supportTickets", ticketId, "messages"),
    orderBy("createdAt", "asc")
  );
  return onSnapshot(
    messagesQuery,
    (snapshot) => onData(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
    onError
  );
};

export const addSupportMessage = ({ ticketId, body, visibility, user }) => addDoc(
  collection(db, "supportTickets", ticketId, "messages"),
  {
    body: body.trim(),
    visibility,
    senderType: "staff",
    senderId: user.uid,
    senderName: user.displayName || user.email || "Destek ekibi",
    attachments: [],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  }
);
